// REST uses epoch seconds; realtime serializes the first-reply Time as ISO.
// Missing/malformed data is unknown and must not assert no human has replied.
export function conversationTimestamp(value) {
  if (typeof value === 'number') return Number.isFinite(value) && value > 0 ? value : 0;
  if (typeof value !== 'string' || !value.trim()) return 0;
  const trimmed = value.trim();
  const seconds = /^\d+(?:\.\d+)?$/.test(trimmed) ? Number(trimmed) : Date.parse(trimmed) / 1000;
  return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
}

export function firstReplyState(chat) {
  if (!Object.prototype.hasOwnProperty.call(chat || {}, 'first_reply_created_at')) return 'unknown';
  const value = chat.first_reply_created_at;
  if (value === null || value === 0 || value === '0' || value === '') return 'none';
  return conversationTimestamp(value) > 0 ? 'recorded' : 'unknown';
}
